import React, {useMemo, useState} from "react";
import "./index.scss";
import classNames from "classnames";
import {FormControl, FormHelperText, InputLabel, MenuItem, Select} from "@material-ui/core";
import KeyboardArrowDownOutlined from '@material-ui/icons/KeyboardArrowDownOutlined'
import {SelectProps} from "@material-ui/core/Select/Select";

export interface SelectOption {
    label: string;
    value: any;
}

interface Props extends Omit<SelectProps, 'onChange'> {
    name?: string;
    options?: SelectOption[];
    placeholder?: string;
    disabled?: boolean;
    hidden?: boolean;
    validationError?: string;
    onChange?: (value: any) => void;
    formatValue?: (value: string) => string;
    formatResponse?: (value: string) => string;
    value?: string;
    className?: string;
}

export const SelectOneInput = (props: Props) => {
    const {
        name,
        hidden,
        disabled,
        error,
        validationError,
        onChange,
        formatResponse,
        formatValue,
        value,
        options,
        placeholder,
        ...rest
    } = props;

    const [open, setOpen] = useState<boolean>(false);

    let className: string = classNames({
        "select-one-input": true,
    });
    if (props.className) {
        className = `${className} ${props.className}`
    }

    const handleClose = () => {
        setOpen(false);
    };

    const handleOpen = () => {
        setOpen(true);
    };

    const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
        const value = event.target.value;
        const formattedValue = formatResponse && typeof value === "string" ? formatResponse(value) : value;

        onChange(formattedValue);
    };

    const getTitle = () => {
        let selectOption = options.find(({value: optionValue})  => optionValue === value);

        return selectOption?.label;
    };

    const fieldValue = useMemo(() => formatValue ? formatValue(value) : value, [value]);

    return (
        <div className={className} hidden={hidden}>
            <FormControl className={`select-one-input__select ${open ? 'arrow-style-open' : 'arrow-style-close'}`} error={error} variant="outlined"
                         fullWidth={true}>
                <InputLabel id="demo-simple-select-outlined-label">{placeholder}</InputLabel>
                <Select
                    {...rest}
                    labelId={name}
                    id={name}
                    value={fieldValue}
                    title={getTitle()}
                    disabled={disabled}
                    open={open}
                    onClose={handleClose}
                    onOpen={handleOpen}
                    IconComponent={KeyboardArrowDownOutlined}
                    MenuProps={{
                        getContentAnchorEl: null,
                        anchorOrigin: {
                            vertical: "bottom",
                            horizontal: "left",
                        },
                        transitionDuration: 0,
                    }}
                    onChange={handleChange}
                    label={placeholder}
                >
                    {options.map((option) => (
                        <MenuItem
                            key={option.value}
                            value={option.value}
                            className='select-one-input__item'
                        >
                            {option.label}
                        </MenuItem>
                    ))}
                </Select>

                {error && <FormHelperText>{validationError}</FormHelperText>}
            </FormControl>
        </div>
    )
};
